import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.7_4a8337f7cc5e1adf1aa3c31aff32febe/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/apps/console/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}